import { render, staticRenderFns } from "./ServiceConfigUserList.vue?vue&type=template&id=295865f5&"
import script from "./ServiceConfigUserList.vue?vue&type=script&lang=js&"
export * from "./ServiceConfigUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports